module.exports = __webpack_public_path__ + "img/logo.021085bd.png";